<template>
  <transition name="fade" mode="out-in">
    <div class="history">
      <div class="history-topBar">
        <span class="btn-back iconfont" @click="hide">&#xe61c;</span>
        <span class="title">历史记录</span>
      </div>
      <div class="history-wrap">
        <table class="his-header">
          <tr>
            <th class="periods" @click.stop="toggleSort()"><span>期次</span><span
              class="iconfont" :class="{active:isSort}">&#xe65d;</span></th>
            <th class="redBall">红球</th>
            <th class="blueBall">篮球</th>
          </tr>
        </table>
        <div class="his-content" ref="history">
          <div>
            <table class="his-body">
              <tr v-for="item in codeList">
                <td class="periods">{{item.index}}期</td>
                <td class="redBall">{{item.red}}</td>
                <td class="blueBall">{{item.blue}}</td>
              </tr>
            </table>
            <div class="down-load" v-show="showLoad"><img src="../images/loading.gif" class="icon-load"></div>
          </div>
        </div>
      </div>
      <div class="history-bottomBar">
        <span class="time-text">距016期投注截止:</span>
        <span class="time">00时00分</span>
      </div>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
  import BScroll from 'better-scroll';
  export default{
    data() {
      return {
        myCode1: {index: 185, red: '09 13 18 20 27 31', blue: '16'},
        myCode2: {index: 186, red: '01 03 11 21 27 33', blue: '07'},
        isSort: false,
        count: 20,
        showLoad: false
      };
    },
    mounted() {
      this.$nextTick(() => {
        this._initScroll();
      });
    },
    watch: {
      codeList() {
        this.$nextTick(() => {
          this._initScroll();
        });
      }
    },
    methods: {
      hide() {
        this.$emit('hide');
      },
      toggleSort() {
        this.isSort = !this.isSort;
      },
      loadData(y) {
        let height1 = this.$refs['history'].getElementsByClassName('his-body')[0].clientHeight;
        let height2 = this.$refs['history'].clientHeight;
        if (y > (height1 - height2)) {
          this.showLoad = true;
          if (loadTime) {
            clearTimeout(loadTime);
          }
          var loadTime = setTimeout(() => {
            this.count = this.count + 20;
            this.showLoad = false;
            this.$nextTick(() => {
              this.hisScroll.refresh();
            });
          }, 2000);
        }
      },
      _initScroll() {
        if (!this.hisScroll) {
          this.hisScroll = new BScroll(this.$refs.history, {
            click: true
          });
          this.hisScroll.on('touchend', (pos) => {
            this.loadData(Math.floor(Math.abs(pos.y)));
          });
        } else {
          this.hisScroll.refresh();
        }
      }
    },
    computed: {
      codeList() {
        let list = [];
        let count = this.count;
        for (let i = 0; i < count; i++) {
          list.push(this.myCode1);
          list.push(this.myCode2);
        }
        if (this.isSort) {
          list.reverse();
        }
        return list;
      }
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  .history
    position:fixed
    z-index:100
    top:0
    left:0
    right:0
    bottom:0
    width:100%
    overflow:hidden
    background-color:#fff
    &.fade-enter-active, &.fade-leave-active
      transition:all 0.2s linear
    &.fade-enter, &.fade-leave-active
      transform:scale(1, 0)
    .history-topBar
      width:100%
      height:40px
      color:#fff
      background-color:#d91d36
      .btn-back
        padding:0 10px
        font-weight:600
        font-size:16px
        line-height:40px
      .title
        font-size:17px
        font-weight:600
        line-height:40px
        letter-spacing:2px
    .history-wrap
      width:100%
      text-align:center
      .his-header
        width:100%
        .periods, .redBall, .blueBall
          padding:10px 0px
          font-size:16px
          color:#83868c
        .periods
          width:20%
          border-bottom:1px solid #cdcdcd
          border-right:1px solid #cdcdcd
          .iconfont
            display:inline-block
            color:#d91d36
            font-weight:normal
            &.active
              transform:rotate(180deg)
        .redBall
          border-bottom:1px solid #cdcdcd
          border-right:1px solid #cdcdcd
        .blueBall
          width:20%
          border-bottom:1px solid #cdcdcd
      .his-content
        position:fixed
        z-index:101
        top:78px
        bottom:40px
        left:0
        right:0
        width:100%
        overflow:hidden
        .his-body
          width:100%
          background-color:#f6f5ef
          tr:nth-of-type(even)
            background-color:#fff
          .periods, .redBall, .blueBall
            padding:10px 0px
            font-size:16px
            color:#83868c
          .periods
            width:20%
            border-right:1px solid #cdcdcd
          .redBall
            color:#d91d36
            border-right:1px solid #cdcdcd
          .blueBall
            width:20%
            color:rgb(20, 120, 220)
        .down-load
          padding:20px
          width:100%
          text-align:center
          .icon-load
            width:20px
            height:20px
    .history-bottomBar
      position:fixed
      z-index:102
      left:0
      bottom:0
      width:100%
      height:40px
      text-align:center
      background-color:#fff
      border-top:1px solid #cdcdcd
      .time-text
        font-size:16px
        line-height:40px
        vertical-align:top
      .time
        font-size:16px
        line-height:40px
        color:#d91d36
        vertical-align:top
</style>



// WEBPACK FOOTER //
// history.vue?629cc2d6